var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup_wrap"},[_c('div',{staticClass:"popup_box"},[_vm._t("icon"),_vm._t("content"),_vm._t("button_wrap")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }